/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { space, color, display } from '@style'

/**
 * Facebook Icon
 * @param {https://github.com/adamwathan/entypo-optimized} param0
 */
function Icon({ size, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      width={size}
      height={size}
      {...props}
      fill="currentcolor"
    >
      <path d="M4.254 19.567c.307-.982.77-2.364 1.391-4.362 2.707-.429 3.827.341 5.546-2.729-1.395.427-3.077-.792-2.987-1.321.091-.528 3.913.381 6.416-3.173-3.155.696-4.164-.836-3.757-1.067.939-.534 3.726-.222 5.212-1.669.766-.745 1.125-2.556.813-3.202-.374-.781-2.656-1.946-3.914-1.836-1.258.109-3.231 4.79-3.817 4.754-.584-.037-.703-2.098.319-4.013-1.077.477-3.051 1.959-3.67 3.226-1.153 2.357.108 7.766-.296 7.958-.405.193-1.766-2.481-2.172-3.694-.555 1.859-.568 3.721 1.053 6.194-.611 1.623-.945 3.491-.996 4.441-.024.759.724.922.859.493z" />
    </svg>
  )
}

Icon.propTypes = {
  size: PropTypes.oneOf([12, 24, 48]).isRequired,
}

const Feather = styled(Icon)([], space, color, display)

Feather.displayName = 'Feather'

Feather.defaultProps = {
  size: 24,
}

export default Feather
